import React from "react";
import moment from "moment";
import { Typography, Paper, makeStyles, Chip, Box } from "@material-ui/core";

const useCardStyles = makeStyles((theme) => ({
  paper: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    padding: theme.spacing(1),
    cursor: "pointer",
    transition: "all 0.3s ease",
    textAlign: "left",
    height: 120,
    margin: theme.spacing(0, 1),
    backgroundColor: theme.palette.background.paper,
    width: "100%",
    maxWidth: "350px",
    minWidth: "240px",

    "&:hover": {
      transform: "scale(1.02)",
      boxShadow: theme.shadows[2],
    },

    [theme.breakpoints.down("xs")]: {
      padding: theme.spacing(1.5),
      maxWidth: "220px",
    },
  },
  lightBlue: {
    backgroundColor: "#e3f2fd",
  },
  lightPink: {
    backgroundColor: "#f3e5f5",
  },
  lightLight: {
    backgroundColor: "#e8f5f3",
  },
  parrotGreen: {
    backgroundColor: "#c8f9b6",
  },
  disabledPaper: {
    filter: "grayscale(30%)",
    "&:hover": {
      transform: "none",
      boxShadow: theme.shadows[3],
    },
  },
  highlight: {
    position: "relative",
    zIndex: 0,
    "&::before": {
      content: '""',
      position: "absolute",
      inset: 0,
      padding: "2px",
      borderRadius: "inherit",
      background: "linear-gradient(90deg, #8a2be2, #00f7ff, #8a2be2)",
      backgroundSize: "300% 300%",
      animation: "$borderRun 3s linear infinite",
      WebkitMask:
        "linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)",
      WebkitMaskComposite: "xor",
      maskComposite: "exclude",
      pointerEvents: "none",
      zIndex: 1,
    },
  },
  "@keyframes borderRun": {
    "0%": { backgroundPosition: "0% 50%" },
    "50%": { backgroundPosition: "100% 50%" },
    "100%": { backgroundPosition: "0% 50%" },
  },

  date: {
    fontSize: "0.75rem",
    color: theme.palette.text.primary,
    marginBottom: theme.spacing(1),
  },
}));

const TimelineCard = ({ item, onClick }) => {
  let status = item.status;
  if ("Pending" === status) {
    status = "Upcoming";
  }
  const classes = useCardStyles();
  const attended = item.enrollmentStatus === "Attended";
  return (
    <Paper
      className={`${classes.paper}
    ${!["Upcoming", "Completed"].includes(status) ? classes.disabledPaper : ""}
    ${getWorkshopClass(status, classes)}
    ${
      ["Open", "Enrolled"].includes(item.enrollmentStatus)
        ? classes.highlight
        : ""
    }`}
      onClick={onClick}
    >
      <Box display="flex" alignItems="center" justifyContent="space-between">
        <Typography className={classes.date}>
          {moment(item.date).format("LL")}
          <br />
          {"4 to 5 PM"}
        </Typography>

        <Box
          display="flex"
          flexWrap="wrap"
          alignItems="center"
          justifyContent={"flex-end"}
        >
          <Chip
            label={status}
            size="small"
            className="mb-2"
            style={{
              fontSize: 10,
              minWidth: "unset",
            }}
            color={
              status === "Completed"
                ? "primary"
                : status === "Upcoming"
                ? "secondary"
                : "default"
            }
            variant="outlined"
          />
          {item.enrollmentStatus && (
            <Chip
              label={item.enrollmentStatus}
              size="small"
              className="mb-2"
              style={{
                fontSize: 10,
                minWidth: "unset",
                marginLeft: 8,
                color: attended ? "#4caf50" : "#2196f3",
                borderColor: attended ? "#4caf50" : "#2196f3",
              }}
              variant="outlined"
            />
          )}
        </Box>
      </Box>
      <div>
        <Typography variant="h6" style={{ fontSize: "14px" }}>
          {item.domain}
        </Typography>

        <Typography variant="body2" style={{ fontSize: "11px" }}>
          {item.title}
        </Typography>
      </div>
    </Paper>
  );
};

const getWorkshopClass = (status, classes) => {
  switch (status) {
    case "Upcoming":
      return classes.lightPink;
      break;
    case "Pending":
      return classes.lightBlue;
      break;
    case "Ongoing":
      return classes.parrotGreen;
      break;
    default:
      return classes.lightLight;
      break;
  }
};

export default TimelineCard;
